export const DashboardFooter = (props) => {
  const { content, buildVersion } = props
  return (
    <div className="dashboard-footer" 
      style={{ height: buildVersion ? '50px' : '30px' }}
    >
      <b color="black">{content?.companyName}</b>
      {buildVersion && (
        <div
          style={{
            fontSize: '12px',
            color: 'black',
          }}
        >
          {buildVersion}
        </div>
      )}
    </div>
  )
}
